import { Role } from '@app/domain-interfaces';
import { Auth } from '@app/web-components';

import { BundleDetail } from '../../pages';

export const useEditBundleAccess = () => {
  const { user } = Auth.useUserAuth();

  const hasBundleOwnership = (data?: BundleDetail) =>
    user?.roles[Role.SYSTEM_ADMIN] || data?.owners.some(({ ownerId }) => ownerId === user?.id);

  return { user, hasBundleOwnership };
};
